import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/transitional/components/Select';
//@ts-expect-error untyped import
import { useFetchDatasetById } from 'reporting-snowflake/dataset/dataset-meta';
import { getColumnLabel } from 'reporting-snowflake/relational/utils/column-utils';
import { DATASET_TABLE } from 'reporting-snowflake/relational/schema/table-records';
import { createRelationalReportFromBaseReport } from 'reporting-snowflake/relational/utils/report-utils';
import { DataSourceTypes } from 'reporting-snowflake/relational/schema/data-source';
import { applyConditionalFormattingToColumn, getIsColumnSupportedByConditionalFormatting, updateSnowflakeReportEncodingWithConditionalFormatting } from '../utils';
import { useSnowflakeReportUpdater } from 'reporting-snowflake/relational/updaters/report/use-snowflake-updater';
import { EVENTS } from '../../../lib/events';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const SnowflakeConditionalFormattingColumnSelect = ({
  report,
  reportDeps,
  onChange,
  selectedColumnName,
  onChangeColumn,
  tracker
}) => {
  var _snowflakeReport$visu;
  const snowflakeReport = createRelationalReportFromBaseReport(report);
  const {
    columns,
    table,
    expressions
  } = snowflakeReport;
  const encodings = (_snowflakeReport$visu = snowflakeReport.visual) === null || _snowflakeReport$visu === void 0 ? void 0 : _snowflakeReport$visu.encodings;
  const encodedColumns = encodings.get('columns').map(encodedColumn => encodedColumn.column);
  const {
    data: dataset
  } = useFetchDatasetById(table.datasetId, true, table.type === DataSourceTypes.HUBSPOT_GLOBAL_DATASET);
  const {
    tableDescriptionMeta
  } = reportDeps;
  const snowflakeUpdater = useSnowflakeReportUpdater(snowflakeReport);
  const {
    properties,
    tables
  } = tableDescriptionMeta;
  const columnTypes = {};
  const columnOptions = columns.filter(column => {
    const snowflakeProperty = properties && properties.getIn([column.field.table, column.field.name]);
    return getIsColumnSupportedByConditionalFormatting(column, snowflakeProperty);
  }).filter(column => encodedColumns === null || encodedColumns === void 0 ? void 0 : encodedColumns.includes(column.get('alias'))).map(column => {
    var _snowflakeProperty$me;
    const maybeDatasetField = column.field.table === DATASET_TABLE && dataset && dataset.getIn(['datasetDefinition', 'fields', column.field.name]);
    const snowflakeProperty = properties && properties.getIn([column.field.table, column.field.name]);
    const snowflakeTable = tables && tables.get(column.field.table || '');
    columnTypes[column.get('alias')] = snowflakeProperty === null || snowflakeProperty === void 0 || (_snowflakeProperty$me = snowflakeProperty.metaDefinition) === null || _snowflakeProperty$me === void 0 ? void 0 : _snowflakeProperty$me.numberDisplayHint;
    return column.get('name') || getColumnLabel(column, snowflakeProperty, snowflakeTable, maybeDatasetField, expressions, table);
  });
  const options = columnOptions.map((value, key) => ({
    text: value,
    value: key
  })).sortBy(c => encodedColumns === null || encodedColumns === void 0 ? void 0 : encodedColumns.indexOf(c.value)).toArray();
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(FormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "report-customization-components.customization-components.conditional-formatting.dropdown.label"
      }),
      labelTooltip: options.length === 0 ? I18n.text('report-customization-components.customization-components.conditional-formatting.dropdown.empty-state') : undefined,
      children: /*#__PURE__*/_jsx(Select, {
        "data-test-id": "conditional-formatting-column-select",
        options: options,
        disabled: options.length === 0,
        onChange: ({
          target: {
            value
          }
        }) => {
          tracker === null || tracker === void 0 || tracker.track(EVENTS.conditionalFormattingInteraction, {
            actionType: 'selectColumn',
            columnType: columnTypes[value] || 'number'
          });
          const column = columns.get(value);
          const encoding = encodings.get('columns').find(encodedColumn => encodedColumn.column === column.get('alias'));
          const toIndex = encodings.get('columns').indexOf(encoding);
          const nextEncoding = applyConditionalFormattingToColumn(snowflakeReport, value);
          if (nextEncoding) {
            const nextReport = updateSnowflakeReportEncodingWithConditionalFormatting({
              updatedEncoding: nextEncoding,
              toIndex,
              snowflakeUpdater
            });
            if (nextReport) {
              onChange(nextReport);
            }
          }
          onChangeColumn(value);
        },
        value: selectedColumnName,
        placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "report-customization-components.customization-components.conditional-formatting.dropdown.placeholder"
        })
      })
    })
  });
};